import React, { Component } from "react";
import RenderFormField from "./RenderFormField";
import { Row, Col } from "react-bootstrap";
import "./form-field.style.scss";
import { yesNoOptions } from "./constants";
import RenderFormFieldView from "./RenderFormFieldView";

export default class CustomerInfoRetail extends Component {
  render() {
    const RenderCom = this.props.isView ? RenderFormFieldView : RenderFormField;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <p className="FormTitle">Customer Information</p>
          </Col>
        </Row>
        <Row>
          {customerInfoRetailFields.map((field) => (
            <Col key={field.name} xs={12} md={field.fullWidth ? 12 : 6}>
              <RenderCom {...field} formValues={this.props.formValues} />
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}

const customerInfoRetailFields = [
  {
    name: "business_purpose_loan_flag",
    type: "dropdown",
    label: "Does customer have business purpose loan?",
    options: yesNoOptions,
  },
  {
    name: "customers_loan_has_collateral_flag",
    type: "dropdown",
    label: "Does customer's loan have collateral?",
    options: yesNoOptions,
  },
  {
    name: "customer_id",
    type: "input",
    label: "Customer ID",
  },
  {
    name: "name",
    type: "input",
    label: "Customer Name",
  },
  {
    name: "gender",
    type: "dropdown",
    label: "Gender",
    options: [
      { label: "Female", value: "Female" },
      { label: "Male", value: "Male" },
    ],
  },
  {
    name: "date_of_birth",
    type: "datePicker",
    label: "Date of birth",
  },
  {
    name: "address",
    type: "input",
    label: "Address",
  },
  {
    name: "identification",
    type: "input",
    label: "Identification",
  },
  {
    type: "space",
    fullWidth: true,
    height: "1px",
  },
  {
    name: "historical_rating_rating_date",
    type: "datePicker",
    label: "Latest rating date",
  },
  {
    name: "historical_rating_rm_id",
    type: "input",
    label: "RM ID",
  },
  {
    name: "historical_rating_branch",
    type: "input",
    label: "Branch",
  },
  {
    name: "historical_rating_rating_id",
    type: "input",
    label: "Rating ID",
  },
  {
    name: "historical_rating_latest_rating",
    type: "input",
    label: "Customer's latest rating",
  },
];



// WEBPACK FOOTER //
// src/pages/Pricing/NewPricing/components/CustomerInfoRetail.js